export type RunDetailUrlState = {
  panel?: string;
  task?: string;
  attempt?: number;
  span?: string;
  group?: string;
  view?: 'timeline' | 'graph';
  q?: string;
  errors?: boolean;
};

function readLegacyRunDetail(value: string): RunDetailUrlState {
  let legacy: Record<string, string>;

  try {
    legacy = JSON.parse(value) as Record<string, string>;
  } catch {
    return {};
  }

  return {
    ...(legacy.tab ? { panel: legacy.tab } : {}),
    ...(legacy.task ? { task: legacy.task } : {}),
    ...(legacy.span ? { span: legacy.span } : {}),
    ...(legacy.group ? { group: legacy.group } : {}),
    ...(legacy.q ? { q: legacy.q } : {}),
  };
}

export function readRunDetailUrl(params: URLSearchParams): RunDetailUrlState {
  const value = params.get('rd');
  const legacy = value ? readLegacyRunDetail(value) : {};
  const attempt = params.get('attempt');
  const view = params.get('view');

  return {
    ...legacy,
    ...(params.get('panel') ? { panel: params.get('panel')! } : {}),
    ...(params.get('task') ? { task: params.get('task')! } : {}),
    ...(attempt ? { attempt: Number(attempt) } : {}),
    ...(params.get('span') ? { span: params.get('span')! } : {}),
    ...(params.get('group') ? { group: params.get('group')! } : {}),
    ...(view === 'timeline' || view === 'graph' ? { view } : {}),
    ...(params.get('q') ? { q: params.get('q')! } : {}),
    ...(params.get('errors') === 'true' ? { errors: true } : {}),
  };
}

export function writeRunDetailUrl(
  params: URLSearchParams,
  panel: string | undefined,
  task: string | undefined,
  attempt: number | undefined,
  span: string | undefined,
  group: string | undefined,
  view: 'timeline' | 'graph' | undefined,
  q: string | undefined,
  errors: boolean | undefined,
): URLSearchParams {
  const next = new URLSearchParams(params);
  const values = {
    panel,
    task,
    attempt: attempt?.toString(),
    span,
    group,
    view,
    q,
    errors: errors ? 'true' : undefined,
  };

  next.delete('rd');
  Object.entries(values).forEach(([key, value]) => {
    if (value) {
      next.set(key, value);
    } else {
      next.delete(key);
    }
  });

  return next;
}
